import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const AddProduct = () => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    category: '',
    stock: 0,
    recipes: '',
  });
  const [images, setImages] = useState([]);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setImages(e.target.files);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (images.length === 0) {
      setMessage('Please select at least one image.');
      return;
    }

    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => data.append(key, value));
    for (let i = 0; i < images.length; i++) {
      data.append('images', images[i]);
    }

    try {
      const token = localStorage.getItem('token');
      await api.post('products', data, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
      });
      setMessage('✅ Product added successfully');
      navigate('/products');
    } catch (error) {
      console.error('Error adding product:', error);
      setMessage(error.response?.data?.message || '❌ Error adding product');
    }
  };

  return (
    <div className="container mt-5 mb-5">
      <h2 className="text-success fw-bold mb-4">Add a New Product</h2>

      {message && (
        <div className="alert alert-info text-center fw-semibold">
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} encType="multipart/form-data" className="border p-4 rounded shadow-sm bg-white">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="name" className="form-label fw-semibold text-success">Product Name *</label>
            <input 
              type="text"
              className="form-control"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="E.g., Cannoli Siciliani"
            />
          </div>
          <div className="col-md-6 mb-3">
            <label htmlFor="category" className="form-label fw-semibold text-success">Category *</label>
            <input 
              type="text"
              className="form-control"
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
              placeholder="E.g., Dolci"
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="description" className="form-label fw-semibold text-success">Description *</label>
          <textarea 
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={formData.description}
            onChange={handleChange}
            required
            placeholder="Describe your product in a few words..."
          ></textarea>
        </div>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label htmlFor="price" className="form-label fw-semibold text-success">Price (€) *</label>
            <input 
              type="number"
              step="0.01"
              className="form-control"
              id="price"
              name="price"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4 mb-3">
            <label htmlFor="stock" className="form-label fw-semibold text-success">Stock</label>
            <input 
              type="number"
              className="form-control"
              id="stock"
              name="stock"
              value={formData.stock}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label htmlFor="images" className="form-label fw-semibold text-success">Product Images *</label>
            <input 
              type="file"
              className="form-control"
              id="images"
              name="images"
              onChange={handleFileChange}
              multiple
              accept="image/*"
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <label htmlFor="recipes" className="form-label fw-semibold text-success">Recipes (one per line)</label>
          <textarea 
            className="form-control"
            id="recipes"
            name="recipes"
            rows="3"
            value={formData.recipes}
            onChange={handleChange}
            placeholder="E.g., 1. Pasta con pesto...\n2. Biscotti al vino..."
          ></textarea>
        </div>

        <div className="d-grid">
          <button type="submit" className="btn btn-success fw-bold">
            ➕ Add Product
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProduct;
